export class NotyficationMessageStateModel {
    public save_info:boolean = false;
    public errors_save: boolean = false;
}